/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Image_RejectedInputs */

const vi_error_shop_image_rejected = /** @type {(inputs: Error_Shop_Image_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không lưu được ảnh (ảnh quá lớn hoặc hỏng).`)
};

/**

* @param {Error_Shop_Image_RejectedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_image_rejected = /** @type {((inputs?: Error_Shop_Image_RejectedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Image_RejectedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_image_rejected(inputs)
});